import { TextAreaProps } from 'antd/es/input';
import React from 'react';
import styled from 'styled-components';
import {
  TextArea as AntdTextArea,
  NewTextArea,
} from 'components/atoms/input/text-area';
import { useAntdRlUISwitcher } from 'contexts/antd-rlui-switcher';

const TextAreaComponent = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props, ref) => {
    const isNewDesignEnabled = useAntdRlUISwitcher();

    if (isNewDesignEnabled) {
      // eslint-disable-next-line react/jsx-props-no-spreading
      return <NewTextArea {...props} ref={ref} />;
    }

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <AntdTextArea {...props} ref={ref} />;
  },
);

TextAreaComponent.displayName = 'TextAreaComponent';

// Create a styled component to enable CSS interpolation like ${TextArea}
export const TextArea = styled(TextAreaComponent)`` as typeof AntdTextArea;

TextArea.displayName = 'TextArea';
